import { CustomerT } from "../../../types";
import React from "react";
import { formatMoney } from "../../../utils";
import { useTranslation } from "react-i18next";
import { Annotation } from "../../../@types/annotation";
import AnnotationComponent from "../../common/Annotation/AnnotationComponent";
import useAnnotations from "../../../hooks/annotation/useAnnotations";

interface CustomerContactProps {
  customer: CustomerT;
  currency: string;
}
export const OutstandingAmount: React.FC<CustomerContactProps> = ({
  customer,
  currency,
}) => {
  const { t } = useTranslation("customer");
  const [annotations, setAnnotations] = React.useState<Annotation[]>([]);
  const annotationsData = useAnnotations(annotations, "Customer");
  
  return (
    <div className="mt-8 md:mt-[2em] flex flex-col md:flex-row md:justify-between md:items-center gap-6">
      <div className="flex justify-between">
        <div>
        <h2 className="text-[20px] font-semibold leading-7 text-[#212121]">{`${customer?.firstName} ${customer?.lastName}`}</h2>
        <p>{customer?.email}</p>
        </div>
        <div className="md:hidden">
        <AnnotationComponent
                type=""
                annotationData={annotationsData}
              />
        </div>
      </div>
   
      <div className="flex flex-col md:justify-end md:items-end gap-2">
      <p className="font-medium text-[#212121] text-[16px] leading-4">
        {" "}
        Outstanding
        {/* {t("customer.amountOutstanding")} */}
      </p>
      <p className="text-[#ef4444] bg-[#FEF3F2] items-baseline text-[18px] font-semibold px-3 py-1 rounded  self-start  inline-block">
        {formatMoney(
          customer?.totalOutstandings ? customer?.totalOutstandings : 0,
          currency,
        )}
      </p>
      </div>
    </div>
  );
};
